import { getEnvironmentVariables } from 'utility/environment';
import { isServer } from 'utility/isServer';

declare global {
  interface Window {
    heap: {
      appid?: string;
      config?: Record<string, unknown>;
      load?: (appId: string, config?: Record<string, unknown>) => void;
      push?: (args: unknown[]) => void;
      [key: string]: any; // Dynamic function keys for heap methods
    };
  }
}

export const initializeHeap = () => {
  const { ENABLE_HEAP, HEAP_APP_ID } = getEnvironmentVariables() || {};

  if (String(ENABLE_HEAP) !== 'true' || isServer()) {
    return;
  }

  window.heap = window.heap || [];
  if (!window.heap.load) {
    window.heap.load = (
      app_id: string,
      config: Record<string, unknown> = {}
    ) => {
      /* istanbul ignore next */
      {
        window.heap.appid = app_id || '';
        window.heap.config = config || {};
      }
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://cdn.heapanalytics.com/js/heap-${app_id}.js`;

      const head = document.getElementsByTagName('head')[0];
      head.appendChild(script);

      /* istanbul ignore next */
      const methodWrapper =
        (methodName: string) =>
        (...args: unknown[]) => {
          window.heap.push?.([methodName, ...args]);
        };

      const heapMethods = [
        'addEventProperties',
        'addUserProperties',
        'clearEventProperties',
        'identify',
        'resetIdentity',
        'removeEventProperty',
        'setEventProperties',
        'track',
        'unsetEventProperty'
      ];

      for (const method of heapMethods) {
        window.heap[method] = methodWrapper(method);
      }
    };
  }
  if (HEAP_APP_ID) {
    window.heap.load(HEAP_APP_ID);
  }
};
